import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LPGDistService, LPGDistData } from '../../../lpg-dist.service';
import momentJ from 'moment-jalaali';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { TrucksService, Truck } from '../../../../transportation';
import { ActivatedRoute, Router } from '@angular/router';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { forkJoin } from 'rxjs';
import { PgTitleComponent } from '../../../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialDateRangeComponent, DateRange } from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MatInputModule } from '@angular/material/input';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-lpg-dist-entry',
  templateUrl: './lpg-dist-entry.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatIconModule,
    SharedModule,
    MaterialDateRangeComponent,
    MaterialOrganisationSelectorComponent,
    MatInputModule,
    MatButtonModule,
    MaterialAutoCompleteComponent,
    MatCheckboxModule,
    MaterialPgInputComponent,
    MatFormFieldModule
  ],
})
export class LpgDistEntryComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();

  trucks: Truck[] = [];
  truck: Truck | undefined;
  trucksForSelection: string[] | undefined;
  lpgDistData: LPGDistData = {
    company: '',
    companyId: '',
    destination: '',
    primaryDestination: '',
    destinationOrganisationId: '',
    source: '',
    sourceOrganisationId: '',
    billOfLadingNumber: '',
    loadTimestamp: 0,
    unloadTimestamp: 0,
    loadingWeight: 0,
    truckNumber: '',
    tankNumber: '',
    driverName: '',
    comments: '',
    isDeleted: false,
    unload: false,
    verify: false,
    contractNo: '',
    transporterOrganisationId: '',
    modify: {
      insertedOn: new Date().getTime(),
      updatedOn: new Date().getTime()
    },
  };
  companies: Organisation[] = [];
  sources: Organisation[] = [];
  organisations: Organisation[] = [];
  destinations: Organisation[] = [];
  mode!: string;
  dataRange!: DateRange;

  company: Organisation | undefined;
  source: Organisation | undefined;
  destination: Organisation | undefined;
  primaryDestination: Organisation | undefined;

  importedData: LPGDistData[] = [];
  sourceSummary: any[] = [];

  message!: string;
  hideTable: boolean = false;
  success: boolean = false;
  errorMessage!: string;
  weight!: number;
  companyId!: string;
  loadTimestamp!: number;
  searchKey!: string;
  remove: boolean = false;
  submitted: boolean = false;
  selectedDate!: DateRange;
  showMessage: boolean = false;

  constructor(private _lpgDistService: LPGDistService,
    private _trucksService: TrucksService,
    private _activatedRoute: ActivatedRoute,
    private _organisationService: OrganisationService,
    private _pgMessagesService: PgMessagesService,
    private _router: Router) { }

  getOrganisationAndTruckData(companyId: string) {
    forkJoin([
      this._trucksService.getForLpgDist(),
      this._organisationService.get(),
    ]).subscribe(results => {
      this.trucks = results[0];
      this.sources = results[1].filter(o => (o.properties['isLoading'] === true));
      this.destinations = results[1].filter(o => (o.properties['isUnloading'] === true));
      this.companies = this._organisationService.getRootOrganisationsLoading(results[1]);
      this.organisations = results[1];
      this.company = this.companies.find(c => c.name === companyId);
      this.initPage();
    });
  }

  setLists() {
    if (!this.lpgDistData.modify) {
      this.lpgDistData.modify = {
        insertedOn: new Date().getTime(),
        updatedOn: new Date().getTime()
      };
    }
    this.selectedDate = {
      startDate: new Date(this.lpgDistData.loadTimestamp),
      endDate: new Date(this.lpgDistData.loadTimestamp)
    };
    this.source = this.sources.find(c => c.name === this.lpgDistData.sourceOrganisationId);
    this.primaryDestination = this.destinations.find(c => c.name === this.lpgDistData.primaryDestination);
  }

  initPage() {
    if (this.mode === 'edit') {
      this._lpgDistService.getLpgDistRecord(this.companyId, this.loadTimestamp, this.searchKey).subscribe(lpg => {
        this.lpgDistData = lpg;
        this.truck = this.trucks.find(trk => trk.formattedRegistrationNumber === this.lpgDistData.truckNumber);
        this.destination = this.destinations.find(c => c.name === this.lpgDistData.destinationOrganisationId);
        this.setLists();
      });
    } else if (this.mode === 'niopdc') {
      this._lpgDistService.getNiopdcRecord(this.searchKey).subscribe(lpg => {
        this.lpgDistData = lpg;
        this.destination = this.destinations.find(c => c.name === this.lpgDistData.destinationOrganisationId);
        this.setLists();
      });
    } else {
      this.organisations = this.organisations.filter(organisation => organisation.properties['allowEnteryFromUI'] === true);
      this.selectedDate = {
        startDate: momentJ().subtract(1, 'days').startOf('day').toDate(),
        endDate: momentJ().subtract(1, 'days').startOf('day').toDate()
      };
    }
  }

  ngOnInit() {
    this.title.emit('Loadings');
    this._activatedRoute.paramMap.subscribe(p => {
      this.mode = p.get('mode') ?? '';
      this.companyId = p.get('company') ?? '';
      this.searchKey = p.get('searchKey') ?? '';
      this.loadTimestamp = + (p.get('loadTimestamp') ?? '0');
      this.getOrganisationAndTruckData(this.companyId);
    });
  }

  organisationValueFormatter(data: Organisation) {
    return data.nameTranslations['fa'];
  }

  changeDestination() {
    this.destination = this.primaryDestination;
  }

  truckValueFormatter(truck: Truck) {
    if (truck) {
      const driver = (typeof truck.driver === 'undefined') ? '' : truck.driver.associatedObject.name;
      const tanker = (typeof truck.tanker === 'undefined') ? '' : truck.tanker.associatedObject.number;
      return truck.formattedRegistrationNumber + ' ' + tanker + ' ' + driver;
    }
    return '';
  }

  onSubmit() {
    this.lpgDistData.company = this.company?.nameTranslations?.['fa'] ?? '';
    this.lpgDistData.companyId = this.company?.name ?? '';
    this.lpgDistData.source = this.source?.nameTranslations?.['fa'] ?? '';
    this.lpgDistData.sourceOrganisationId = this.source?.name ?? '';
    this.lpgDistData.destination = this.destination?.nameTranslations?.['fa'] ?? '';
    this.lpgDistData.primaryDestination = this.primaryDestination?.name ?? '';
    this.lpgDistData.destinationOrganisationId = this.destination?.name ?? '';
    this.lpgDistData.loadTimestamp = this.correctTimestamp(this.selectedDate.startDate);
    this.lpgDistData.unloadTimestamp = this.correctTimestamp(this.selectedDate.startDate);
    this.lpgDistData.truckNumber = this.truck?.formattedRegistrationNumber ?? '';
    this.lpgDistData.tankNumber = (this.truck?.tanker?.associatedObject) ? this.truck.tanker.associatedObject.number : '';
    this.lpgDistData.driverName = (this.truck?.driver?.associatedObject) ?  this.truck.driver.associatedObject.name : '';
    this.lpgDistData.transporterOrganisationId = (this.truck?.organisationId?.associatedObject) ? this.truck.organisationId.associatedObject : '';
    this.lpgDistData.loadingWeight = +this.lpgDistData.loadingWeight;
    if (this.mode !== 'edit') {
      this.lpgDistData.modify!.insertedOn = new Date().getTime();
      this.lpgDistData.modify!.updatedOn = new Date().getTime();
      this._lpgDistService.add(this.lpgDistData)
        .subscribe({
          next: () => {
            this.message = ' داده مورد نظر با شماره بارنامه ' + this.lpgDistData.billOfLadingNumber + ' با موفقیت ثبت شد  ';
            this._pgMessagesService.publishMessage({
              message: this.message,
              topic: 'New Loading',
              level: MessageLevel.Info
            });
            this._router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this._router
                  .navigate([
                    'lpg-dist/data-entry/edit',
                    this.lpgDistData.companyId,
                    this.lpgDistData.loadTimestamp,
                    this.lpgDistData.billOfLadingNumber
                  ]);});
          },
          error: () => {
            this.message = 'Error';
            this._pgMessagesService.publishMessage({
              message: this.message,
              topic: 'Error',
              level: MessageLevel.Error
            });
          }
        });
    } else if (this.mode === 'edit') {
      this.lpgDistData.modify!.updatedOn = new Date().getTime();
      this._lpgDistService.update(this.lpgDistData)
        .subscribe(
          {
            next: () => {
              this.message = ' داده مورد نظر با شماره بارنامه ' + this.lpgDistData.billOfLadingNumber + ' با موفقیت ویرایش شد  ';
              this._pgMessagesService.publishMessage({
                message: this.message,
                topic: 'Edit Loading',
                level: MessageLevel.Info
              });
              this._router
                .navigateByUrl('/', { skipLocationChange: true })
                .then(() => {
                  this._router
                    .navigate([
                      'lpg-dist/data-entry`',
                      this.mode,
                      this.lpgDistData.companyId,
                      this.lpgDistData.loadTimestamp,
                      this.lpgDistData.billOfLadingNumber
                    ])
                    .then((e) => console.log(`Result of Navigation is ${e}`));
                });
            },
            error: () => {
              this.message = 'Error';
              this._pgMessagesService.publishMessage({
                message: this.message,
                topic: 'Error',
                level: MessageLevel.Error
              });
            }
          }
        );
    }
  }

  correctTimestamp(date: Date): number {
    return date.getTime() - (date.getHours() * 3600
      + date.getMinutes() * 60
      + date.getSeconds()) * 1000
      - date.getMilliseconds();
  }

}
